import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

function Testimonials() {
  const { t } = useLocale()

  return (
    <section className="section" aria-labelledby="social-proof">
      <div className="container">
        <h2 id="social-proof">{t.testimonials.title}</h2>
        <p className="lead">{t.testimonials.lead}</p>
        <div className="testimonials">
          <blockquote className="quote">
            "{t.testimonials.alex.quote}"
            <strong>{t.testimonials.alex.author}</strong>
          </blockquote>
          <blockquote className="quote">
            "{t.testimonials.jordan.quote}"
            <strong>{t.testimonials.jordan.author}</strong>
          </blockquote>
          <blockquote className="quote">
            "{t.testimonials.sam.quote}"
            <strong>{t.testimonials.sam.author}</strong>
          </blockquote>
        </div>
      </div>
    </section>
  )
}

export default Testimonials
